import QueryString from "qs";
import dynamic from "next/dynamic";
import { GetServerSideProps, NextPage } from "next";
const Page410 = dynamic(() => import("@/Components/410/410"));
const BlogPage = dynamic(() => import("@/Components/pages/blog"), {
  ssr: true,
});
const HocHead = dynamic(
  () => import("@/Components/HigherOrderComponent/HocHead"),
  { ssr: true }
);

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL;

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const slug = "blog";
  if (process.env.NEXT_PUBLIC_CACHE_PAGES) {
    ctx.res.setHeader(
      "Cache-Control",
      "public, s-maxage=18000, stale-while-revalidate=59"
    );
  }

  let apiRes = null;
  let apiResData = null;
  let isNew = false;
  const query = QueryString.stringify(
    {
      filters: {
        slug: {
          $eq: "blog",
        },
      },
      populate: "deep, 6",
    },
    {
      encodeValuesOnly: false,
    }
  );
  apiRes = await fetch(`${baseUrl}articles?${decodeURIComponent(query)}`);
  apiResData = await apiRes.json();
  isNew = apiResData?.data[0]?.attributes?.design === "new";
  return {
    props: {
      apiResData,
      slug,
      status: 200,
      isNew,
    },
  };
};

interface BlogDetailProps {
  apiResData: any;
  slug: string;
  status: number;
  isNew: boolean;
}
const BlogDetail: NextPage<BlogDetailProps> = ({
  apiResData,
  slug,
  status,
}) => {
  const blocks = apiResData.data[0]?.attributes.blocks;
  const seo = apiResData.data[0]?.attributes.seo;

  return (
    <div id="root">
      {seo && <HocHead seo={seo} />}
      {status == 410 ? (
        <Page410 />
      ) : (
        <div>
          <BlogPage slug={slug} data={blocks} />
        </div>
      )}
    </div>
  );
};

export default BlogDetail;
